/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BookingStrictHttpResponse } from '../../booking-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MedicalAdvisorConfirmReservationRequestModel } from '../../models/medical-advisor-confirm-reservation-request-model';

export interface ApiMedicalAdvisorConfirmReservationConfirmReservationPost$Params {
      body?: MedicalAdvisorConfirmReservationRequestModel
}

export function apiMedicalAdvisorConfirmReservationConfirmReservationPost(http: HttpClient, rootUrl: string, params?: ApiMedicalAdvisorConfirmReservationConfirmReservationPost$Params, context?: HttpContext): Observable<BookingStrictHttpResponse<string | null>> {
  const rb = new RequestBuilder(rootUrl, apiMedicalAdvisorConfirmReservationConfirmReservationPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BookingStrictHttpResponse<string | null>;
    })
  );
}

apiMedicalAdvisorConfirmReservationConfirmReservationPost.PATH = '/api/MedicalAdvisor/ConfirmReservation/ConfirmReservation';
